import React, { useEffect, useState } from 'react'
import ActiveWorkoutSection from './components/active-workout-section';
import ExercisesTable from './components/exercises-table-section';
import LoadingIndicator from '../../components/LoadingIndicator';
import { useMutation, useQuery } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';
import Button from '../../components/Button';
import { produce } from 'immer';
import { useTranslation } from 'react-i18next';
import { useEndActiveWorkoutMutation, useGetActiveWorkoutQuery } from 'src/graphql';

const ActiveWorkoutScreen: React.FC = () => {

    const [workoutExerciseId, setWorkoutExerciseId] = useState<string>()

    const { data, loading, error, refetch: refetchActiveWorkout } = useGetActiveWorkoutQuery({
        onCompleted(data) {
            setWorkoutExerciseId(data.getActiveWorkout?.exercises?.[0]?.id)
        }
    });

    const [URLSearchParams, SetURLSearchParams] = useSearchParams()

    const [finishWorkout, { loading: FinishWorkoutPending }] = useEndActiveWorkoutMutation({
        onCompleted() {
            window.location.href = '/';
        }
    });

    useEffect(() => {
        if (URLSearchParams.get('active') === '1') {
            refetchActiveWorkout()
        }
    }, [URLSearchParams])

    const finishWorkoutPressed = () => {
        finishWorkout()
    }

    const { t } = useTranslation();

    if (loading) {
        return (
            <div className='h-screen flex items-center justify-center gap-2'>
                <LoadingIndicator />
            </div>
        )
    }

    if (error) {
        return <div>{error.message}</div>
    }

    if (!data?.getActiveWorkout) {
        return <div>{t("You dont have any active workout")}</div>
    }

    if (data?.getActiveWorkout.end_at) {
        return <div>{t("You've finished today's workout")}</div>
    }

    return (
        <div className='space-y-6'>
            <ActiveWorkoutSection workoutExerciseId={workoutExerciseId!} activeWorkout={data.getActiveWorkout} />
            <ExercisesTable onPressExercise={(id) => {
                setWorkoutExerciseId(id)
                window.scrollTo({
                    top: 0
                })
            }} workoutExercises={data.getActiveWorkout.exercises || []} />
            <Button onClick={() => finishWorkoutPressed()} disabled={FinishWorkoutPending}>
                {t("finish")}
            </Button>
        </div>
    )
}

export default ActiveWorkoutScreen;